import React, { useState, useEffect } from 'react';
import SceneMarketingResultStyled from './SceneMarketingResultStyled';
// import SearchCondition from './searchCondition/index';
import DataTableNativeML from '@/components/DataTableNativeML';
import { useTheme, IconButton } from '@material-ui/core';
import styles from '../../../../cm/mm/components/table_page/TablePage.less?modules';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { useDispatch, useSelector } from 'dva';
import { history } from 'umi';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import { useIntl } from 'umi';
import webStorage from '@/utils/storageManager';

export default (props) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const { setModification, setPageData, pagination } = props;
  // const pageData = props.pageData;
  const dispatch = useDispatch();
  const theme = useTheme();

  const [suspendOpen, setSuspendOpen] = useState(false);
  const [suspendId, setSuspendId] = useState();
  const [dialogTitle, setDialogTitle] = useState();
  const [dialogContent, setDialogContent] = useState();
  // const [isRestart, setIsRestart] = useState({});

  // const levelList = [
  //   {
  //     code: 1,
  //     // name: '初履会员',
  //     name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl07' }),
  //   },
  //   {
  //     code: 2,
  //     // name: '心履会员',
  //     name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl08' }),
  //   },
  //   {
  //     code: 3,
  //     // name: '优履会员',
  //     name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl09' }),
  //   },
  //   {
  //     code: 4,
  //     // name: '奢履会员',
  //     name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl10' }),
  //   },
  // ];
  const memberLevel = useSelector((state) => state.sceneMarketing.memberLevel);

  const sceneMarketingList = useSelector(
    (state) => state.sceneMarketing.sceneMarketingList,
  );

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['sceneMarketing/getSceneMarketingList'];

  const { data, total } = sceneMarketingList || {};
  const userAuths = webStorage.get('USER')?.authorities;
  const buttonsAuth = [
    'MENU_MARKETING_SCENE_DETAIL',
    'MENU_MARKETING_SCENE_LEVEL_CHANGE',
    'MENU_MARKETING_SCENE_CONSUMPTION',
    'MENU_MARKETING_SCENE_BIND',
    'MENU_MARKETING_SCENE_MEMBER',
    'MENU_MARKETING_SCENE_BIRTHDAY',
    'MENU_MARKETING_SCENE_REGISTRATION',
    'MENU_MARKETING_SCENE_FESTIVAL',
    'MENU_MARKETING_SCENE_ECOMMERCE',
    'MENU_MARKETING_SCENE_POINT_USE',
    'MENU_MARKETING_SCENE_MEMBER_REPURCHASE',
  ];
  const filterAuth = buttonsAuth.filter((i) => userAuths.includes(i)) || [];
  const onlyDetail =
    filterAuth.length === 1 && filterAuth[0] === 'MENU_MARKETING_SCENE_DETAIL';
  //换页
  // const changePage = (obj) => {
  //   handlePageChange(obj);
  // };

  const handleMarketingDetail = (item, isDetail, sourceOid, status) => {
    let toDetail = new Map([
      // ['会员注册营销', ['/marketing/scene/registration']],
      [
        formatMessage({ id: 'marketing.scene.n02.lbl01' }),
        ['/marketing/scene/registration'],
      ],
      // ['生日营销', ['/marketing/scene/birthday']],
      [
        formatMessage({ id: 'marketing.scene.n03.lbl01' }),
        ['/marketing/scene/birthday'],
      ],
      [
        formatMessage({ id: 'marketing.scene.n04.lbl01' }),
        ['/marketing/scene/member'],
      ],
      // ['会员日营销', ['/marketing/scene/member']],
      [
        formatMessage({ id: 'marketing.scene.n01.lbl01' }),
        ['/marketing/scene/festival'],
      ],
      // ['节日营销', ['/marketing/scene/festival']],
      // ['会员绑定', ['/marketing/scene/bind']],
      [
        formatMessage({ id: 'marketing.scene.n05.lbl01' }),
        ['/marketing/scene/bind'],
      ],
      // ['会员消费', ['/marketing/scene/consumption']],
      [
        formatMessage({ id: 'marketing.scene.n06.lbl01' }),
        ['/marketing/scene/consumption'],
      ],
      // ['等级变更', ['/marketing/scene/level_change']],
      [
        formatMessage({ id: 'marketing.scene.n07.lbl01' }),
        ['/marketing/scene/level_change'],
      ],
      // ['积分使用', ['/marketing/scene/point_use']],
      [
        formatMessage({ id: 'marketing.scene.n08.lbl01' }),
        ['/marketing/scene/point_use'],
      ],
      ['抽奖活动', ['/marketing/activity']],
      ['电商渠道', ['/marketing/scene/ec_channels_reach']],
      ['会员复购', ['/marketing/scene/repurchase']],
    ]);
    history.push({
      pathname: status
        ? toDetail.get(`${item.type}`) + '_detail'
        : toDetail.get(`${item.type}`),
      query: {
        id: String(item.id),
        opt: isDetail,
        sourceOid,
      },
    });
  };

  // 数据分析页面
  // const toSceneData = (itm) => {
  //   history.push({
  //     pathname: '/marketing/scene/activity-view',
  //     query: {
  //       id: itm.id,
  //       // opt: isDetail,
  //     },
  //   });
  // };

  const handleClose = () => {
    setSuspendOpen(false);
    setSuspendId();
  };

  const handleSuspendOpen = (item, action) => {
    if (action === 'suspend') {
      // 暂停
      setSuspendId(item.id);
      setSuspendOpen(true);
      // setDialogContent('确定要暂停该活动吗');
      setDialogContent(formatMessage({ id: 'marketing.scene.d01.txt01' }));
      // setDialogTitle('暂停');
      setDialogTitle(formatMessage({ id: 'comm.action.btn.10' }));
    }
    if (action === 'end') {
      // 终止
      setSuspendOpen(true);
      setSuspendId(item.id);
      // setDialogContent('确定要终止该活动吗');
      setDialogContent(formatMessage({ id: 'marketing.scene.d03.txt01' }));
      // setDialogTitle('终止');
      setDialogTitle(formatMessage({ id: 'comm.action.btn.11' }));
    }
    if (action === 'restart') {
      // 重启
      setSuspendOpen(true);
      setSuspendId(item.id);
      // setDialogContent('确定要重启该活动吗');
      setDialogContent(formatMessage({ id: 'marketing.scene.d02.txt01' }));
      // setDialogTitle('重启');
      setDialogTitle(formatMessage({ id: 'comm.action.btn.18' }));
    }
    if (action === 'approve') {
      // 审批
      setSuspendOpen(true);
      setSuspendId(item.id);
      setDialogContent(formatMessage({ id: 'marketing.scene.d04.txt01' }));
      // setDialogContent('确定要通过审核吗？');
      // setDialogTitle('审核');
      setDialogTitle(formatMessage({ id: 'comm.action.btn.12' }));
    }
  };

  const handleSuspend = () => {
    if (dialogTitle === formatMessage({ id: 'comm.action.btn.10' })) {
      dispatch({
        type: 'sceneMarketing/handleSuspendSceneMarketing',
        payload: {
          values: {
            id: suspendId,
            status: 'PAUSE',
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: formatMessage({ id: 'marketing.scene.c01.tip01' }),
              title: formatMessage({ id: 'marketing.scene.c01.tip01' }),
            });
            setSuspendOpen(false);
            setModification({});
          } else {
            window.message.toast({
              type: 'error',
              message: res.message,
              title: res.message,
            });
            setSuspendOpen(false);
          }
        },
      });
    }
    if (dialogTitle === formatMessage({ id: 'comm.action.btn.11' })) {
      dispatch({
        type: 'sceneMarketing/handleSuspendSceneMarketing',
        payload: {
          values: {
            id: suspendId,
            status: 'TERMINATE',
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            setSuspendOpen(false);
            window.message.toast({
              type: 'success',
              message: formatMessage({ id: 'marketing.scene.c01.tip02' }),
              title: formatMessage({ id: 'marketing.scene.c01.tip02' }),
            });
            setModification({});
          } else {
            window.message.toast({
              type: 'error',
              message: res.message,
              title: res.message,
            });
            setSuspendOpen(false);
          }
        },
      });
    }
    if (dialogTitle === formatMessage({ id: 'comm.action.btn.12' })) {
      dispatch({
        type: 'sceneMarketing/ApproveSceneMarketing',
        payload: {
          values: {
            id: suspendId,
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            setSuspendOpen(false);
            window.message.toast({
              type: 'success',
              message: formatMessage({ id: 'marketing.scene.c01.tip03' }),
              title: formatMessage({ id: 'marketing.scene.c01.tip03' }),
            });
            setModification({});
          } else {
            window.message.toast({
              type: 'error',
              message: res.message,
              title: res.message,
            });
            setSuspendOpen(false);
          }
        },
      });
    }
    if (dialogTitle === formatMessage({ id: 'comm.action.btn.18' })) {
      dispatch({
        type: 'sceneMarketing/RestartSceneMarketing',
        payload: {
          values: {
            id: suspendId,
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            setSuspendOpen(false);
            window.message.toast({
              type: 'success',
              message: formatMessage({ id: 'marketing.scene.c01.tip04' }),
              title: formatMessage({ id: 'marketing.scene.c01.tip04' }),
            });
            setModification({});
          } else {
            window.message.toast({
              type: 'error',
              message: res.message,
              title: res.message,
            });
            setSuspendOpen(false);
          }
        },
      });
    }
  };

  // 根据不同状态 显示不同按钮
  // 重启 => 暂停
  const isShow = (status, action) => {
    let showStatus = new Map([
      // ['待审核_restart', ['true']],
      // ['待审核_suspend', ['true']],
      // ['待审核_end', ['true']],
      // ['未开始_restart', ['true']],
      // ['未开始_approve', ['true']],
      // ['未开始_edit', ['true']],
      // ['进行中_restart', ['true']],
      // ['进行中_edit', ['true']],
      // ['进行中_approve', ['true']],
      // ['已结束_suspend', ['true']],
      // ['已结束_edit', ['true']],
      // ['已结束_restart', ['true']],
      // ['已结束_end', ['true']],
      // ['已结束_approve', ['true']],
      // ['已暂停_suspend', ['true']],
      // ['已暂停_edit', ['true']],
      // ['已暂停_approve', ['true']],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt01' })}_restart`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt01' })}_suspend`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt01' })}_end`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt02' })}_restart`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt02' })}_approve`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt02' })}_edit`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt03' })}_restart`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt03' })}_edit`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt03' })}_approve`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt04' })}_suspend`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt04' })}_edit`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt04' })}_restart`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt04' })}_end`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt04' })}_approve`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt05' })}_suspend`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt05' })}_edit`,
        ['true'],
      ],
      [
        `${formatMessage({ id: 'marketing.scene.detail.n01.txt05' })}_approve`,
        ['true'],
      ],
    ]);

    return showStatus.get(`${status}_${action}`);
  };

  const columns = [
    {
      align: 'center',
      title: formatMessage({ id: 'marketing.scene.c01.lbl01' }),
      id: 'title',
      width: 178,
    },
    {
      title: formatMessage({ id: 'marketing.scene.c01.lbl02' }),
      align: 'center',
      id: 'type',
      key: 'activityStatus',
      width: 95,
    },
    {
      // title: '活动时间',
      title: formatMessage({ id: 'marketing.scene.c01.lbl03' }),
      align: 'center',
      width: 180,
      render: ({ dateBeginTimestamp, dateEndTimestamp }) => {
        return (
          <div className="date-wrapper">
            <span>{dateBeginTimestamp}</span>
            <span>{dateEndTimestamp}</span>
          </div>
        );
      },
    },
    {
      // title: '会员范围',
      title: formatMessage({ id: 'marketing.scene.c01.lbl04' }),
      id: 'memberLevelScope',
      key: 'memberLevelScope',
      width: 200,
      align: 'center',
      render: ({ memberLevelScope }) => {
        let arr = [];
        memberLevelScope.forEach((element) => {
          const name = memberLevel.filter(
            (i) => i.code?.toString() === element?.toString(),
          )[0];
          arr.push(name?.name);
        });
        return <div>{arr.join(' ')}</div>;
      },
    },
    {
      // title: '状态',
      title: formatMessage({ id: 'marketing.scene.c01.lbl05' }),
      align: 'center',
      id: 'activityStatus',
      key: 'activityStatus',
      width: 90,
    },
    {
      // title: '操作',
      title: formatMessage({ id: 'marketing.scene.c01.lbl06' }),
      // width: 120,
      align: 'center',
      render: (item) => {
        return (
          <div align="center" className={styles.handle_btn}>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.03' })}>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_scene_marketing_list_edit',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: item.id,
                  },
                })}
                onClick={() =>
                  !onlyDetail &&
                  !isShow(item.activityStatus, 'edit') &&
                  handleMarketingDetail(
                    item,
                    'edit',
                    'btn_marketing_activity_scene_marketing_list_edit',
                  )
                }
              >
                <SvgIconML
                  size={24}
                  className={
                    onlyDetail || isShow(item.activityStatus, 'edit')
                      ? 'icon-disabled'
                      : 'icon'
                  }
                  name={'edit'}
                ></SvgIconML>
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.05' })}>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_scene_marketing_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: item.id,
                  },
                })}
                onClick={() =>
                  handleMarketingDetail(
                    item,
                    'detail',
                    'btn_marketing_activity_scene_marketing_list_details',
                    1,
                  )
                }
              >
                <SvgIconML
                  size={24}
                  className="icon"
                  name={'detail'}
                ></SvgIconML>
              </IconButton>
            </ButtonTip>
            {/* 暂停和重启 */}
            {/* <ButtonTip title={formatMessage({ id: 'comm.action.btn.09' })}>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => toSceneData(item)}
              >
                <SvgIconML
                  size={24}
                  className="icon"
                  name={'sceneData'}
                ></SvgIconML>
              </IconButton>
            </ButtonTip> */}
            <ButtonTip
              // title={isShow(item.activityStatus, 'pause') ? 'Pause' : 'restart'}
              title={
                !isShow(item.activityStatus, 'restart')
                  ? formatMessage({ id: 'comm.action.btn.18' })
                  : formatMessage({ id: 'comm.action.btn.10' })
              }
            >
              {/* 中止 */}
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_scene_marketing_list_pause',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: item.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                className={
                  isShow(
                    item.activityStatus,
                    !isShow(item.activityStatus, 'restart') ? 'restart' : 'end',
                  )
                    ? 'disabled'
                    : ''
                }
                onClick={() =>
                  !onlyDetail &&
                  !isShow(
                    item.activityStatus,
                    !isShow(item.activityStatus, 'restart') ? 'restart' : 'end',
                  ) &&
                  handleSuspendOpen(
                    item,
                    !isShow(item.activityStatus, 'restart')
                      ? 'restart'
                      : 'suspend',
                  )
                }
              >
                <SvgIconML
                  size={24}
                  name={
                    !isShow(item.activityStatus, 'restart')
                      ? 'restart'
                      : 'pause'
                  }
                  // name={!isShow(item.activityStatus, 'pause') ? 'pause' : 'restart'}
                  className={
                    onlyDetail ||
                    isShow(
                      item.activityStatus,
                      !isShow(item.activityStatus, 'restart')
                        ? 'restart'
                        : 'end',
                    )
                      ? 'icon-disabled'
                      : 'icon'
                  }
                ></SvgIconML>
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.11' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_scene_marketing_list_terminate',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: item.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() =>
                  !onlyDetail &&
                  !isShow(item.activityStatus, 'end') &&
                  handleSuspendOpen(item, 'end')
                }
                className={isShow(item.activityStatus, 'end') ? 'disabled' : ''}
              >
                <SvgIconML
                  size={24}
                  name={'stop'}
                  // name={isShow(item.activityStatus, 'end') ? 'stop' : 'restart'}
                  className={
                    onlyDetail || isShow(item.activityStatus, 'end')
                      ? 'icon-disabled'
                      : 'icon'
                  }
                ></SvgIconML>
              </IconButton>
            </ButtonTip>

            <ButtonTip title={formatMessage({ id: 'comm.action.btn.12' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_scene_marketing_list_review',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: item.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                className={
                  isShow(item.activityStatus, 'approve') ? 'disabled' : ''
                }
                // 审批
                onClick={() =>
                  !onlyDetail &&
                  !isShow(item.activityStatus, 'approve') &&
                  handleSuspendOpen(item, 'approve')
                }
              >
                <SvgIconML
                  size={24}
                  name={'approve'}
                  className={
                    onlyDetail || isShow(item.activityStatus, 'approve')
                      ? 'icon-disabled'
                      : 'icon'
                  }
                ></SvgIconML>
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
      width: 200,
    },
  ];
  // 获取会员等级列表
  useEffect(() => {
    dispatch({ type: 'sceneMarketing/getMemberLevel' });
  }, [dispatch]);

  return (
    <SceneMarketingResultStyled theme={theme}>
      <DataTableNativeML
        total={total}
        loading={loading}
        paging={true}
        columns={columns}
        // pageData={pageData}
        page={pagination}
        // changePage={changePage}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={data}
      ></DataTableNativeML>
      <DialogDataML
        open={suspendOpen}
        title={dialogTitle}
        content={dialogContent}
        handleClose={handleClose}
        handleConfirm={handleSuspend}
      ></DialogDataML>
    </SceneMarketingResultStyled>
  );
};
